import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import useSubscription from "shared/services/subscriptions";
import { names } from "shared/services/subscriptions/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const Organizations = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) || INITIAL_VALUES.skip,
    take: parseInt(filter.take) || INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.ORGANIZATIONS, {
    variables,
  });
  useSubscription({ query: names.ORGANIZATIONS, variables });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "organizations",
      }}
    />
  );
};

Organizations.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Organizations.defaultProps = {
  filter: {},
};

export default Organizations;
